import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { PlayCircleIcon, HelpCircleIcon, ClockIcon } from 'lucide-react';
const painPoints = [{
  icon: PlayCircleIcon,
  text: 'Ves videos virales todos los días… pero no sabes cómo se hacen'
}, {
  icon: HelpCircleIcon,
  text: 'No sabes qué tipo de contenido crear'
}, {
  icon: ClockIcon,
  text: 'Sientes que podrías hacerlo… pero no sabes por dónde empezar'
}];
export function PainSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-6 bg-dark-secondary" data-id="element-130">
      <div className="max-w-5xl mx-auto" data-id="element-131">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif font-bold text-text-primary mb-16 text-center" data-id="element-132">
          Si estás aquí, probablemente te pasa esto:
        </motion.h2>

        <div className="max-w-2xl mx-auto space-y-5 mb-14" data-id="element-133">
          {painPoints.map((point, index) => {
          const Icon = point.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: index * 0.12
          }} className="flex items-start gap-4 p-6 bg-dark-bg/50 rounded-lg border border-dark-tertiary" data-id="element-134">
                <Icon className="w-6 h-6 text-accent flex-shrink-0 mt-1" data-id="element-135" />
                <p className="text-lg text-text-secondary" data-id="element-136">{point.text}</p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-center" data-id="element-137">
          <p className="text-xl md:text-2xl text-text-primary font-medium mb-3" data-id="element-138">
            Y mientras tanto…
          </p>
          <p className="text-lg md:text-xl text-accent italic" data-id="element-139">
            otras personas ya están creando contenido que crece y capta atención
            usando herramientas simples.
          </p>
        </motion.div>
      </div>
    </section>;
}